import { isUnderRoute, toAppPath } from './appPath';

/**
 * 초기 설정이 끝난 뒤 갈 곳 — 프로필 게이트가 `/setup` 으로 돌려보낸 원래 목적지.
 *
 * 딥링크로 결과 화면에 들어온 사람이 프로필이 없어 설정부터 하게 되면, 설정을 마친 뒤
 * 홈이 아니라 그 결과 화면으로 가야 한다. 목적지는 history state 로만 나른다 — 저장소에
 * 남기지 않으니 앱을 새로 열면 사라지고, WebView reload 에는 history 와 함께 남는다.
 */
export interface SetupReturnState {
  from: string;
}

/** 프로필 게이트가 보내는 초기 설정 화면. */
export const SETUP_ROUTE = '/setup';

/** 라우터가 설정 화면으로 맞추는 경로인가 — 대소문자·끝 슬래시가 달라도 같은 화면이다. */
export const isSetupPath = (path: string): boolean =>
  isUnderRoute(path, SETUP_ROUTE);

/** `/setup` 으로 보낼 때 실을 state. */
export const setupReturnState = (from: string): SetupReturnState => ({ from });

/**
 * state 에서 목적지를 읽는다. 앱 안의 경로만 받는다(`toAppPath`) — `/setup` 자신으로
 * 돌아가면 설정이 제자리를 돈다.
 */
export const readReturnTo = (state: unknown): string | null => {
  const from = (state as Partial<SetupReturnState> | null)?.from;
  if (typeof from !== 'string' || !from.startsWith('/')) {
    return null;
  }
  const path = toAppPath(from);
  return path && !isSetupPath(path) ? path : null;
};
